/**
 * SessionExpiryWarning (Welle 6f)
 *
 * Modal das 5 Minuten vor Token-Ablauf gezeigt wird. Zwei Aktionen:
 *  - Abmelden: sofort raus
 *  - Bleiben: schließt das Modal (Token läuft trotzdem ab, gibt nur Aufschub
 *    der Erinnerung; ein echtes Refresh würde Re-Login brauchen)
 */

import { useEffect, useState } from 'react';
import { clearToken, getMsUntilExpiry } from '@/lib/auth';
import { getPendingDocCountSync } from '@/lib/localDocs';

export function SessionExpiryWarning({ onDismiss }: { onDismiss: () => void }) {
  const [secondsLeft, setSecondsLeft] = useState<number>(() => {
    const ms = getMsUntilExpiry();
    return ms !== null ? Math.max(0, Math.round(ms / 1000)) : 0;
  });

  useEffect(() => {
    const id = setInterval(() => {
      const ms = getMsUntilExpiry();
      const s = ms !== null ? Math.max(0, Math.round(ms / 1000)) : 0;
      setSecondsLeft(s);
      if (s <= 0) clearInterval(id);
    }, 1000);
    return () => clearInterval(id);
  }, []);

  const mm = Math.floor(secondsLeft / 60);
  const ss = secondsLeft % 60;
  const formatted = `${mm}:${ss.toString().padStart(2, '0')}`;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
        zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        style={{
          background: 'var(--surface, #1a1a1a)',
          color: 'var(--text, #fff)',
          borderRadius: 8,
          padding: '24px 28px',
          maxWidth: 440,
          width: '100%',
          boxShadow: '0 12px 48px rgba(0,0,0,0.4)',
          border: '1px solid rgba(255,255,255,0.12)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
          <strong style={{ fontSize: 16 }}>Sitzung läuft ab</strong>
        </div>
        <div style={{ fontSize: 14, opacity: 0.85, marginBottom: 18, lineHeight: 1.5 }}>
          Ihre Sitzung endet in <strong style={{ fontVariantNumeric: 'tabular-nums' }}>{formatted}</strong>.
          Danach werden Sie automatisch abgemeldet und müssen sich neu anmelden,
          um weiterhin Anrufe entgegenzunehmen.
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            onClick={() => { if (getPendingDocCountSync() === 0 || window.confirm(`Es liegen noch ${getPendingDocCountSync()} nicht abgelegte Dokumente lokal vor. Trotzdem abmelden?`)) clearToken(); }}
            style={{
              padding: '8px 14px',
              background: 'transparent',
              color: 'currentColor',
              border: '1px solid rgba(255,255,255,0.25)',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: 13,
            }}
          >
            Jetzt abmelden
          </button>
          <button
            onClick={onDismiss}
            style={{
              padding: '8px 14px',
              background: 'currentColor',
              color: '#000',
              border: '1px solid currentColor',
              borderRadius: 4,
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            Verstanden
          </button>
        </div>
      </div>
    </div>
  );
}
